import { useTranslation } from 'react-i18next';
import { FunctionComponent } from 'react';
import { Col, Row } from 'antd';

import DisabledElement from 'components/disabledElement/disabledElement';
import FilePreview from 'components/filePreview/filePreview';
import { PrivateEquityIssuance } from '../models/privateEquityIssuance';
import PrivateEquityIssuanceShareholdersTable from './PrivateEquityShareholdersTable';
import dayjs from 'dayjs';

interface PrivateEquityIssuanceComponentProps {
	privateEquityIssuance?: PrivateEquityIssuance;
}

const PrivateEquityIssuanceComponent: FunctionComponent<PrivateEquityIssuanceComponentProps> = ({ privateEquityIssuance }) => {
	const { t } = useTranslation();

	return (
		<>
			<Row gutter={[16, 16]}>
				<Col span={24} md={8}>
					<DisabledElement label={t('ACTIONS.ISSUING_DATE')} value={dayjs(privateEquityIssuance?.action.issuing_date).format('DD-MM-YYYY')} />
				</Col>

				<Col span={24} md={8}>
					<DisabledElement label={t('ACTIONS.TOTAL_NEW_COMMON_SHARES')} value={privateEquityIssuance?.action.number_of_issued_units} />
				</Col>

				<Col span={24} md={8}>
					<DisabledElement label={t('ACTIONS.ISSUANCE_PRICE')} value={privateEquityIssuance?.action.issuing_price} />
				</Col>
			</Row>

			{privateEquityIssuance?.action?.new_capital_document?.download_link && (
				<Row gutter={[16, 16]} className="mt-3">
					<Col span={24} md={12}>
						<FilePreview name={t('ACTIONS.NEW_CAPITAL_DOCUMENT')} downloadLink={privateEquityIssuance.action.new_capital_document.download_link} />
					</Col>
				</Row>
			)}

			<PrivateEquityIssuanceShareholdersTable privateEquityIssuance={privateEquityIssuance!} viewOnly />
		</>
	);
};

export default PrivateEquityIssuanceComponent;
